import { createApp, h, provide } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import i18n from '@/composables/useI18n'
import { useGrafanaFaro } from '@/composables/useGrafanaFaro'
import { VueQueryPlugin } from '@tanstack/vue-query'
import { createApolloClient } from '@/utils/apollo'
import { ApolloClients, provideApolloClients } from '@vue/apollo-composable'
import Vue3TouchEvents, { type Vue3TouchEventsOptions } from 'vue3-touch-events'
import floatingVue from '@/composables/useFloatingVue'
import { useCustomParams } from '@/composables/useCustomParams'
import Clarity from '@microsoft/clarity'
import '@/assets/styles/main.css'
import { v4 as uuidv4 } from 'uuid'

const apolloClients = {
  mia: createApolloClient(import.meta.env.VITE_MIA_API_GRAPHQL_URL, {
    'x-api-key': import.meta.env.VITE_MIA_API_KEY
  })
}

const pinia = createPinia()

const app = createApp({
  setup() {
    provide(ApolloClients, apolloClients)
  },
  render: () => h(App)
})

useGrafanaFaro()
provideApolloClients(apolloClients)

const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID || 'qqxrufpydgu'
Clarity.init(projectId)
const { language, prompt, username, source, email, user_id, url } = useCustomParams()
const guid = uuidv4()
if (user_id && email == null) {
  Clarity.identify(user_id)
}
if (user_id == null && email) {
  Clarity.identify(email)
}

Clarity.consent(false)
Clarity.event('initialized')
Clarity.setTag('source', source)
Clarity.setTag('language', language)

app
  .use(pinia)
  .use(i18n)
  .use(floatingVue)
  .use(VueQueryPlugin)
  .use<Vue3TouchEventsOptions>(Vue3TouchEvents, {
    disableClick: false
  })
  .mount('#chat-widget')
